<template>
  <div class="bill-check">
    <Modal v-model="showModal" width="700" style="text-align: left" :mask-closable="false" class="bill-check-modal">
      <p style="margin-bottom: 10px;">
        <!-- <Icon type="android-alert" size="30" color="red"></Icon> -->
        <img src="../images/bill-check-modal-icon.png" class="icon">
      </p>
      <div style="margin: 0 25px;">
        <p class="text title">尊敬的客户您好:</p>
        <p v-if="message" class="text">· {{message}}</p>
        <p class="text" v-if="alertText">
        {{alertText}}
        <span class='info'>(未确认<span style="color: red;font-size:20px;">{{billNum}}</span>条)</span>
        <Button type="text" @click="handleCheckBill" style="text-decoration: underline;color: #ff9900;font-size: 12px;padding: 0;font-size: 14px;">前往确认</Button>
        <span>。</span>
      </p>
      </div>
      <div slot="footer" class="footer">
        <div>
          <Button type="warning" style="width: 142px; height: 38px;font-size: 18px;" @click="handlePlaceOrder" v-if="overdueDays < 5 && allowBooking">立即下单</Button>  
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import dayjs from "dayjs"
import util from "@/libs/util";
import { checkBill } from "@/api/containerBalance"
import Cookies from 'js-cookie';
import {  decode } from "@/libs/encrypt-and-decode.js"
export default {
  data() {
    return {
      showModal: false,
      alertText: "",
      billNum: 0,
      overdueDays: 0,
      message:'',
      overdueLimit: false,
      allowBooking: true,
    };
  },
  methods: {
    handlePlaceOrder() {
      this.showModal = false;
      this.$store.commit('closePage','create-detail-order')
      this.$store.commit('removeTag','create-detail-order')
      this.$emit("place-order");
    },
    handleCheckBill() {
      this.$router.push({
        name: "fee-confirmation_index",
        params: {
          chargeConfirmStatus: "CUSTOMER_CHARGE_UNCONFIRMED"
        }
      })
    },
    showCheckBill() {
      
      checkBill().then(res => {
        util.customer_ajax_post(this, '/company/overdue_limit',{},(limitRes)=>{
          let { count, planArrivalTime, days = 0 } = JSON.parse(res.data.data.value)
          let {overdueLimit, message, allowBooking} = limitRes.data.data
          this.billNum = count
          this.overdueDays = days
          this.message = message
          this.overdueLimit = overdueLimit
          this.allowBooking = allowBooking
          // days = 4
          // debugger
          let testUser = ['demo_portsh', 'demo_portnb', 'demo_portqd', 'demo_portsz', 'demo_porttj', 'demo_porttc', 'demo_sme1', 'demo_sme2', 'demo_sme3', 'demo_citydg', 'demo_citygz', 'demo_cityfs', 'demo_cityzs' ,'demo_cityhz']
         if (testUser.includes(decode(Cookies.get('user')))){
              this.$store.commit('closePage','create-detail-order')
              this.$store.commit('removeTag','create-detail-order')
              this.$emit("place-order");
              this.showModal = false
              return
          }
          if (count <= 0) {
            // 暂无未对账, 直接跳转下一步下单
            if (this.overdueLimit) {
              this.showModal = true
            }else{
              this.$store.commit('closePage','create-detail-order')
              this.$store.commit('removeTag','create-detail-order')
              this.$emit("place-order");
              this.showModal = false
              return
            }
          }
          if (days >= 5) {
            // this.alertText = `您${dayjs(planArrivalTime).format("M月D日")}的日账单还未确认</br>确认完成后方可恢复下单`
            this.alertText = planArrivalTime ? `· 您${dayjs(planArrivalTime).format("M月D日")}的日账单还未确认,确认完成后方可恢复下单` : null
            this.showModal = true
          } else if(days >= 0){
            // this.alertText = `您${dayjs(planArrivalTime).format("M月D日")}的日账单还未确认</br>未确认达5天将无法下单`
            this.alertText = planArrivalTime ? `· 您${dayjs(planArrivalTime).format("M月D日")}的日账单还未确认,未确认达5天将无法下单` : null
            this.showModal = true
          } else {
          // 暂无未对账, 直接跳转下一步下单
            if (this.overdueLimit) {
              this.showModal = true
            } else {
              this.$emit("place-order");
              this.showModal = false
            }
          }
        })
        
      })
    }
  },
};
</script>

<style lang="less" scoped>
.footer {
  text-align: center;
  padding-bottom: 30px;
}
</style>
<style lang="less">
.bill-check-modal {
  .ivu-modal-footer {
    border-top: none;
  }
  .info {
    text-align: center;
    font-size: 14px;
    color: #787272;
    margin-top: 40px;
  }
  .icon {
    margin: 20px auto 10px auto;
    width: 85px;
  }
  .text {
    word-wrap:break-word;
    font-size: 14px; 
    text-indent:2em;
    color: #787272;
    line-height: 28px;
    &.title{
      text-indent: 0;
      margin-left: 0;
    }
  }
  .ivu-modal-footer{
    padding-top: 2px;
  }
}
</style>



// WEBPACK FOOTER //
// bill-check-modal.vue?9e88ead4